export const FILTER_TYPES = {
  SEE_ALL_REDEEMS: {
    value: 1,
    label: 'Visualizar todos os resgates',
  },
  SEE_CLIENTS_SOLICITATIONS: {
    value: 2,
    label: 'Solicitações de clientes',
  },
};

const APPROVED_COLOR = 'var(--color-success)';
const CANCELED_COLOR = 'var(--color-error)';
const WARNING_COLOR = '#FFA500';

export const OPTIONS_REDEMPTIONS = {
  SEE_ALL_TYPES: {
    value: 0,
    label: 'Visualizar todos os tipos',
  },
  SPOT: {
    value: 1,
    label: 'Spot',
  },
  SPOT_HIERARCHY: {
    value: 2,
    label: 'Spot Hierarquia',
  },
  HIERARCHY: {
    value: 3,
    label: 'Hierarquia',
  },
  DIRECT_QUOTATION: {
    value: 4,
    label: 'Cotação Direta',
  },
};

export const OPTIONS_STATUS = {
  SEE_ALL_STATUS: {
    value: 0,
    label: 'Visualizar todos os status',
    color: WARNING_COLOR,
  },
  WAITING_QUOTATION: {
    value: 1,
    label: 'Aguardando cotação',
    color: WARNING_COLOR,
  },
  PENDING_PMO: {
    value: 2,
    label: 'Pendente - PMO',
    color: WARNING_COLOR,
  },
  PENDING_MANAGER: {
    value: 3,
    label: 'Pendente - Gestor',
    color: WARNING_COLOR,
  },
  WAITING_APPROVAL: {
    value: 4,
    label: 'Aguardando aprovação',
    color: WARNING_COLOR,
  },
  APPROVED: {
    value: 6,
    label: 'Aprovados',
    color: APPROVED_COLOR,
  },
  CANCELED: {
    value: 5,
    label: 'Cancelados',
    color: CANCELED_COLOR,
  },
};

export const OPTIONS_ORDERS_STATUS = {
  SEE_ALL_STATUS: {
    value: 0,
    label: 'Visualizar todos os status',
  },
  PROCESSED_BY_SUPPLIER: {
    value: 1,
    label: 'Processado pelo Fornecedor',
    color: APPROVED_COLOR,
  },
  PAYMENT_AUTHORIZED: {
    value: 2,
    label: 'Pagamento Autorizado',
    color: WARNING_COLOR,
  },
  REFUNDED: {
    value: 3,
    label: 'Estornado',
    color: CANCELED_COLOR,
  },
  ORDER_CREATED: {
    value: 4,
    label: 'Pedido Criado',
    color: WARNING_COLOR,
  },
  COMPLETED: {
    value: 5,
    label: 'Finalizado',
    color: APPROVED_COLOR,
  },
  SHIPPED: {
    value: 6,
    label: 'Enviado',
    color: WARNING_COLOR,
  },
  PARTIALLY_REFUNDED: {
    value: 7,
    label: 'Parcialmente Estornado',
    color: CANCELED_COLOR,
  },
  PAYMENT_DENIED: {
    value: 8,
    label: 'Pagamento Negado',
    color: CANCELED_COLOR,
  },
  AUTHENTICATION_REQUIRED: {
    value: 9,
    label: 'Autenticação Requerida',
    color: WARNING_COLOR,
  },
  AUTHENTICATION_DENIED: {
    value: 10,
    label: 'Autenticação Negada',
    color: CANCELED_COLOR,
  },
  DENIED_BY_SUPPLIER: {
    value: 11,
    label: 'Negado pelo Fornecedor',
    color: CANCELED_COLOR,
  },
  PAYMENT_CONFIRMED: {
    value: 12,
    label: 'Pagamento Confirmado',
    color: APPROVED_COLOR,
  },
  NOT_COMPLETED: {
    value: 13,
    label: 'Não Concluído',
    color: CANCELED_COLOR,
  },
  PAYMENT_REFUNDED: {
    value: 14,
    label: 'Pagamento Estornado',
    color: CANCELED_COLOR,
  },
  RISK_ANALYSIS_DENIED: {
    value: 15,
    label: 'Negado na Análise de Risco',
    color: CANCELED_COLOR,
  },
  INCONSISTENT_ORDER: {
    value: 16,
    label: 'Pedido Inconsistente',
    color: CANCELED_COLOR,
  },
  AWAITING_SUPPLIER_RESPONSE: {
    value: 17,
    label: 'Aguardando Resposta Fornecedor',
    color: WARNING_COLOR,
  },
  PROCESSING_REFUND: {
    value: 18,
    label: 'Em processamento de Estorno',
    color: WARNING_COLOR,
  },
  IN_ANALYSIS: {
    value: 19,
    label: 'Em Análise',
    color: WARNING_COLOR,
  },
};

export const itemsPerPage = [
  { value: 15, label: '15' },
  { value: 30, label: '30' },
  { value: 50, label: '50' },
];

export const datePickerPlaceholder = (PMOReportFilterTypeSelected) => {
  return {
    [FILTER_TYPES.SEE_ALL_REDEEMS.value]: 'Criação',
    [FILTER_TYPES.SEE_CLIENTS_SOLICITATIONS.value]: 'Atualização',
  }[PMOReportFilterTypeSelected] || null;
};

const mapOptions = (options) => {
  return Object.values(options);
};

export const statusOptions = (PMOReportFilterTypeSelected) => {
  switch (PMOReportFilterTypeSelected) {
    case FILTER_TYPES.SEE_CLIENTS_SOLICITATIONS.value:
      return mapOptions(OPTIONS_STATUS);

    case FILTER_TYPES.SEE_ALL_REDEEMS.value:
      return mapOptions(OPTIONS_ORDERS_STATUS);

    default:
      break;
  }
  return null;
};
